// ─── Delays ──────────────────────────────────────────────────────────────────

export const Delays = {
  EMBEDDED_FRAME_LOADING_TIMEOUT: 40_000,
};
